export enum Status {
  Approval_pending = 'Approval_pending',
  Approved = 'Approved',
  Draft = 'Draft',
  Accepted = 'Accepted',
  Open = 'Open',
}
